import React from 'react';
import { MdDarkMode, MdLanguage, MdLightMode } from 'react-icons/md';
import { usePreferences } from '../../contexts/PreferencesContext';

const PreferenceControls = ({ compact = false }) => {
    const {
        language,
        setLanguage,
        setThemePreference,
        t,
        theme,
    } = usePreferences();

    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    const ThemeIcon = nextTheme === 'dark' ? MdDarkMode : MdLightMode;
    const themeTitle = `${t('theme')}: ${nextTheme === 'dark' ? t('dark') : t('light')}`;

    return (
        <div className={`preference-controls ${compact ? 'compact' : ''}`}>
            <button
                type="button"
                className="preference-theme-button"
                aria-label={themeTitle}
                title={themeTitle}
                onClick={() => setThemePreference(nextTheme)}
            >
                <ThemeIcon />
                {!compact && <span>{nextTheme === 'dark' ? t('dark') : t('light')}</span>}
            </button>

            <label className="preference-select">
                <span>
                    <MdLanguage />
                    {!compact && t('language')}
                </span>
                <select
                    aria-label={t('language')}
                    value={language}
                    onChange={(event) => setLanguage(event.target.value)}
                >
                    <option value="pt">Pt</option>
                    <option value="en">En</option>
                    <option value="es">Es</option>
                </select>
            </label>
        </div>
    );
};

export default PreferenceControls;
